module.exports = __webpack_public_path__ + "static/media/half-circle.1a1a0ec3.svg";